import React from 'react'
import PropTypes from 'prop-types'

import layoutQuery from "../hooks/use-layout-query"

import '../assets/scss/main.scss'

import Header from '../components/header'
import Footer from '../components/footer'
import CursorBlob from '../components/cursor-blob'

const Layout = ({ children, location, pageContext }) => {
  const data = layoutQuery()

  React.useEffect(() => {
    document.documentElement.style.setProperty(`--headerColour`, pageContext?.header === 'primary' ? '#FF4200' : '#FFFFFF');
    document.documentElement.style.setProperty(`--secondaryColour`, pageContext?.header === 'primary' ? '#FFFFFF' : '#000000');
  }, [pageContext])

  return (
    <>
      <a href='#main-content' className='skip-link'>Skip to content</a>
      <Header location={location} data={data} pageContext={pageContext} />
      <div className='grain' />
      <CursorBlob />
      <main id='main-content'>{children}</main>
      <Footer data={data} />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
